"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "parseQuery", {
  enumerable: true,
  get: function () {
    return _parseQuery.parseQuery;
  }
});
Object.defineProperty(exports, "serializeQuery", {
  enumerable: true,
  get: function () {
    return _serializeQuery.serializeQuery;
  }
});
var _serializeQuery = require("./serializeQuery");
var _parseQuery = require("./parseQuery");